// src/utils/errorUtils.ts
import { message } from 'antd';
import { put } from 'redux-saga/effects';

/**
 * Generic error handling function for Redux-Saga.
 * @param error The caught error object (can be Axios or other errors).
 * @param failureAction The failure action to dispatch with error message.
 * @param defaultErrorMessage Default error message to show if no detailed message is available.
 */
export function* handleError(
  error: any,
  failureAction: any,
  defaultErrorMessage: string
) {
  if (error?.response) {
    const errorMessage = error?.response?.data?.message || defaultErrorMessage;
    const errorDetails =
      error?.response?.data?.details || 'Currently we are facing some issue';

    // Dispatch failure action with error message
    yield put(failureAction(errorMessage));

    // Show error message to the user
    message.error(`${errorMessage}: ${errorDetails}`);
  } else {
    // For other errors (e.g., network issues or Axios connection errors)
    yield put(failureAction(error?.message || defaultErrorMessage));
    message.error(defaultErrorMessage);
  }
}
